import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PINTEREST_PIN_SYNC_FIELDS_LIST} from "../../constants/pinterest-pin-sync.constant";
import {showDateTime} from "../../../printful/utils/printful-util";
import {
    bulkUpdateDesignContent,
    initiateShopifyProductPriceSync
} from "../../../common/services/cloud-function-service";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {
    searchPinterestPinSyncsWithSearchCriteria,
    updateSinglePinterestPinSync
} from "../../services/pinterest-pin-sync-data.service";
import {generatePinterestPinsForDesigns} from "../../utils/pinterest-sync-util";
import ExportBulkPinterestPins from "./export-bulk-pinterest-pins";


const defaultFilterCriteria: any = {};

const PinterestPinSyncList = () => {
    const [pinterestPinSyncsList, setPinterestPinSyncsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPinterestPinSyncList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({
                    field: attribute,
                    condition: '==',
                    value: value
                });
            }
        });

        const pinterestPinSyncListResult = await searchPinterestPinSyncsWithSearchCriteria(searchCriteriaList);

        _.forEach(pinterestPinSyncListResult, (pinterestPinSync) => {
            let completedCount = 0;
            let inCompletedCount = 0;
            _.forEach(pinterestPinSync.designIds, (designId) => {
                if (pinterestPinSync?.contentStatus && pinterestPinSync?.contentStatus[designId] === 'COMPLETED') {
                    completedCount++;
                } else {
                    inCompletedCount++;
                }
            });

            pinterestPinSync.complete = completedCount;
            pinterestPinSync.inComplete = inCompletedCount;
        });

        // console.log('pinterestPinSyncListResult', pinterestPinSyncListResult);

        setPinterestPinSyncsList(pinterestPinSyncListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPinterestPinSyncList();
    }, [filterCriteria]);

    const refreshPinterestPinSyncList = async () => {
        await getPinterestPinSyncList();
    }

    const startPinterestPinSyncProcessCloudFunction = async (pinterestPinSyncId) => {
        setDataFetchInProgress(true);
        await bulkUpdateDesignContent(pinterestPinSyncId);

        await refreshPinterestPinSyncList();
        setDataFetchInProgress(false);
    }

    const startPinterestPinSyncProcess = async (pinterestPinSync) => {
        setDataFetchInProgress(true);

        pinterestPinSync.status = 'STARTED';
        await updateSinglePinterestPinSync(pinterestPinSync);

        await refreshPinterestPinSyncList();
        setDataFetchInProgress(false);
    }

    const startGeneratePinterestPinsProcess = async (pinterestPinSync) => {
        setDataFetchInProgress(true);
        pinterestPinSync.status = 'STARTED';

        await generatePinterestPinsForDesigns(pinterestPinSync);


        await refreshPinterestPinSyncList();
        setDataFetchInProgress(false);
    }

    const markAsCompleted = async (pinterestPinSync) => {
        setDataFetchInProgress(true);

        pinterestPinSync.status = 'COMPLETED';
        await updateSinglePinterestPinSync(pinterestPinSync);

        await refreshPinterestPinSyncList();
        setDataFetchInProgress(false);
    }


    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Pinterest Pin Sync
                    </div>

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    <div className="">
                        <button
                            className="button-green-outline px-4 py-2 flex items-center justify-center"
                            onClick={refreshPinterestPinSyncList}>
                            <span>Refresh</span>
                            <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={dataFetchInProgress}/>
                            </span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={pinterestPinSyncsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Pinterest Pin Syncs'}/>

                    {pinterestPinSyncsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PINTEREST_PIN_SYNC_FIELDS_LIST?.map((pinterestPinSyncField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${pinterestPinSyncField?.cssClass}`}>{pinterestPinSyncField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {pinterestPinSyncsList?.map((pinterestPinSync, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PINTEREST_PIN_SYNC_FIELDS_LIST?.map((pinterestPinSyncField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${pinterestPinSyncField?.cssClass}`}>
                                                {pinterestPinSyncField?.optionsMap &&
                                                    <>{pinterestPinSyncField?.optionsMap[pinterestPinSync[pinterestPinSyncField?.attribute]]?.name}</>
                                                }

                                                {!pinterestPinSyncField?.optionsMap &&
                                                    <>
                                                        {!pinterestPinSyncField?.isDate &&
                                                            <>
                                                                {pinterestPinSync[pinterestPinSyncField?.attribute]}
                                                            </>
                                                        }

                                                        {pinterestPinSyncField?.isDate &&
                                                            <>
                                                                {showDateTime(pinterestPinSync[pinterestPinSyncField?.attribute])}
                                                            </>
                                                        }

                                                        {pinterestPinSyncField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {pinterestPinSync[pinterestPinSyncField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-64">
                                        <div className="flex justify-center items-center">
                                            {/*{((pinterestPinSync?.status === 'NEW' && pinterestPinSync?.total > 0) || pinterestPinSync?.inComplete > 0) &&
                                                <div className="">
                                                    <button
                                                        className="button-green px-4 py-1"
                                                        onClick={() => {
                                                            startPinterestPinSyncProcess(pinterestPinSync)
                                                        }}>
                                                        <span>Start Pinterest Pin Sync Process</span>
                                                    </button>

                                                    <ExportBulkPinterestPins pinterestPinSync={pinterestPinSync}/>
                                                </div>
                                            }*/}

                                            <div className={'mx-1'}>
                                                <ExportBulkPinterestPins pinterestPinSync={pinterestPinSync}/>
                                            </div>

                                            <div className={'mx-1'}>
                                                <button
                                                    onClick={() => {
                                                        markAsCompleted(pinterestPinSync)
                                                    }}
                                                    className={'button-red-outline px-2 py-1'}>
                                                    Mark as Completed
                                                </button>
                                            </div>

                                            <div className="flex justify-around mx-1">
                                                <CopyDataToClipboard value={JSON.stringify(pinterestPinSync, null, 2)}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PinterestPinSyncList
